export default {
    translations: {
        "Drag 'n' drop some files here, or click to select files": "Arrastra algún comic aquí o haz click para seleccionar el archivo",
        "Drop the files here ...": "Suelta el archivo aquí ...",
        "(We only accept .rar, .zip, .cbr and .cbz)": "(Solo aceptamos archivos: .rar, .zip, .cbr and .cbz)",
        "Maybe the file type is not supported (We only accept .rar, .zip, .cbr and .cbz)": "Quizás este tipo de archivo no es soportado (Solo aceptamos archivos .rar, .zip, .cbr and .cbz)"
    }
}